<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">弱勢助學清冊</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <!--<div class="col-12">
                <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
            </div>-->
            <div class="col-12">
                <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" type="text" student required></form-input>
            </div>
            <div class="col-12">
                <form-select v-model="vm.Category" id="Category" label="補助類別" required>
                    <slot name="category"></slot>
                </form-select>
            </div>
            <div class="col-md col-sm-12">
                <form-input v-model="vm.Amount" id="Amount" label="弱勢補助金額" type="number" required></form-input>
            </div>
            <div class="col-md col-sm-12">
                <form-input v-model="vm.SchoolAmount" id="SchoolAmount" label="學校自籌金額" type="number" required></form-input>
            </div>
            <div class="col-md col-sm-12">
                <form-input v-model="vm.EduAmount" id="EduAmount" label="教育部補助金額" type="number" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'disadvantagedDetail',
        api: '/api/disadvantaged/'
    });
</script>

<style>
</style>